
import { Component, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import VWrapper from '@/components/shared/VWrapper.vue';
import AdyenPlatformSection from '@/components/smoothrPay/AdyenPlatformSection.vue';
import Notification from '@/mixins/Notification';
import api from '@/api/http/SmoothrPayApiService';
import { AdyenPlatformComponent } from '@/enums/SmoothrPay';
import { MerchantConfiguration } from '@/interfaces/models/SmoothrPay';

/**
 * Shared frame for the two embedded Adyen overviews: pick a merchant, then hand
 * its configuration to the SDK. Only merchants that already have an account
 * holder can show anything, but all of them are listed so it is obvious which
 * one still needs provisioning.
 */
@Component({ components: { VWrapper, AdyenPlatformSection } })
export default class AdyenMerchantPanel extends mixins(Notification) {
  @Prop({ type: String, required: true }) public titleKey!: string;
  @Prop({ type: String, required: true }) public subtitleKey!: string;
  @Prop({ type: String, required: true }) public selectMerchantKey!: string;
  @Prop({ type: String, required: true }) public component!: AdyenPlatformComponent;

  public configurations: MerchantConfiguration[] = [];
  public selectedId: string = '';

  get merchantItems() {
    return this.configurations.map((config: MerchantConfiguration) => ({
      text: config.legalEntity ? config.legalEntity.name : config._id,
      value: config._id,
    }));
  }

  get selected(): MerchantConfiguration | null {
    return this.configurations.find((config: MerchantConfiguration) => config._id === this.selectedId) || null;
  }

  public mounted() {
    this.fetch();
  }

  public async fetch() {
    this.$startLoading('smoothrPay.adyen');
    try {
      const { data } = await api.getConfigurations({ page: 1, limit: 100 });
      this.configurations = data.data || [];
      // A single merchant needs no picking.
      if (this.configurations.length === 1) {
        this.selectedId = this.configurations[0]._id;
      }
    } catch (error) {
      this.notifyError('smoothrPay.notification.loadError');
    } finally {
      this.$stopLoading('smoothrPay.adyen');
    }
  }
}
